export enum TypeNotification {
	Success,
	Failed,
	Warning,
	Information
}

export interface Notification {
	id: number;
	type: TypeNotification;
	message: string;
	isNew: boolean;
	time: string;
	numberSecondsDisplay: number
}




// WEBPACK FOOTER //
// ./src/shared/models/notification.ts